module.exports = __webpack_public_path__ + "img/buttonBlueGold.dc090b42.png";